module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2b",
    attrs: {
      "id": "ch10"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#ch-10"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("HOLLYWOOD REWRITES HISTORY")])])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('i', [_vm._v("Nothing good on TV? Rent some of these classic movies and see if you can spot the flubs.")])])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("CAMELOT")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_vm._v("Okay, so maybe the mythical kingdom of Camelot didn’t really exist. But if it did, it probably didn’t have a supply of flesh-colored bandages, like the one King Arthur (Richard Harris) is wearing on the side of his neck while stumbling through the forest looking for Merlin.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("FIELD OF DREAMS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_vm._v("Ray Liotta plays Shoeless Joe Jackson as a right-handed batter. The experts know better: the real Shoeless Joe was a southpaw.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("ONE MILLION YEARS B.C.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_vm._v("Raquel Welch and her cave woman friends are wearing false eyelashes, which was a fad when the film came out in 1966, but probably not the fashion in prehistoric days. But we could be wrong—that’s why they call it "), _c('i', [_vm._v("pre")]), _vm._v("-history.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("THE SEARCHERS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_vm._v("Returning Civil War veteran John Wayne gives his niece a medal that he supposedly won in the war. In actuality, the Confederate Congress approved the design of a medal and a badge of distinction, but there’s no record of one ever having been made. A small number of medals were made and awarded for certain battles, but of the few that were awarded by the end of the war, none were of the same design as Wayne’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("TORA! TORA! TORA!")])])])]), _c('p', {
    staticClass: "noindent0"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('span', [_vm._v("When the Japanese planes fly over Oahu en route to Pearl Harbor, you can distinctly see a white cross that memorializes ")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("the first casualties of World War II; it was erected in 1962. A bit later, in the background, is Tripler Army Hospital, which was built after the war.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', [_c('b', [_vm._v("A BEAUTIFUL MIND")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_vm._v("And for fans of the minutest minutiae, Alicia Nash (Jennifer Connelly), who plays a 1950s housewife to hubby mathematician John Nash (Russell Crowe), owns an orange Tupperware bowl that, according to at least one former Tupperware lady, was not introduced until the mid-to-late 1970s.")])]), _vm._v(" "), _c('p', {
    staticClass: "centeraa"
  }, [_c('span', [_vm._v("* * * * *")])]), _vm._v(" "), _c('p', {
    staticClass: "centeraa"
  }, [_c('span', [_c('b', [_vm._v("LIGHTS, ACTION—OOPS!")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('span', [_c('i', [_vm._v("The Ten Commandments")]), _vm._v(" (1956)—a blind man is seen wearing a watch.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_c('i', [_vm._v("Easy Rider")]), _vm._v(" (1969)—Peter Fonda’s watch changes from a Rolex to a Timex.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_c('i', [_vm._v("Rear Window")]), _vm._v(" (1954)—Jimmy Stewart’s cast switches from his left to his right leg.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_c('i', [_vm._v("The Bible")]), _vm._v(" (1966)—Adam has a belly button.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_c('i', [_vm._v("Butch Cassidy and the Sundance Kid")]), _vm._v(" (1969)—Sundance fires off 17 shots from two six-shooters.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_c('i', [_vm._v("The Two Jakes")]), _vm._v(" (1990 sequel to "), _c('i', [_vm._v("Chinatown")]), _vm._v(")—There’s a shot in which star Jack Nicholson strolls past an ATM. Unfortunately, the film is set in the late 1940s, about 30 years before ATMs were installed in banks.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('span', [_c('i', [_vm._v("Pretty Woman")]), _vm._v(" (1990)—An usher calls Julia Roberts “Julia” instead of “Vivian.”")])]), _vm._v(" "), _c('p', {
    staticClass: "center-box"
  }, [_c('span', [_c('b', [_vm._v("Punishments were harsh in 1725 in East Hampton, Long Island, New York…")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-581f0eec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter10.vue
// module id = 108
// module chunks = 0